var path = 'app/components/auth/auth.html';
var html = "<div class=\"middle-box text-center loginscreen animated fadeInDown\"><div><div><h1 class=\"logo-name\"><img src=\"img/logo.png\"></h1></div><h3>Prijava korisnika</h3><hr><form class=\"m-t\" role=\"form\" ng-submit=\"vm.login()\"><div class=\"form-group\"><input type=\"text\" ng-model=\"vm.username\" class=\"form-control\" placeholder=\"korisnik\" required></div><div class=\"form-group\"><input type=\"password\" ng-model=\"vm.password\" class=\"form-control\" placeholder=\"zaporka\" required></div><button type=\"submit\" class=\"btn btn-primary block full-width m-b\">Prijavi me</button></form><p class=\"m-t\"><small>InVita d.o.o. &copy; 2016</small></p></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/components/auth/auth.html
// module id = 55
// module chunks = 0